import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/nsleche'
      className='link footer__link'
    >
    {/* GitHub */}
    </a>
  </footer>
)

export default Footer
